import useSpaceAccess from '../../hooks/useSpaceAccess'
import { AccessDenied } from '@eggplant/embedded-documentation'

const SpaceAccessDenied = () => {
  const [isAccess] = useSpaceAccess(['dai:user'])

  return (
    <AccessDenied isUser={isAccess} />
  )
}

export default SpaceAccessDenied
